import ApiService from '../services/ApiService';

export default class CountryRepository {
    constructor() {
        this.apiService = new ApiService();
    }

    getCountries() {
        return new Promise((resolve, reject) => {
            this.apiService
                .get('countries')
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}
